import { useEffect, useMemo, useState, type ReactNode } from "react";
import {
  loadSettings,
  persistSettings,
  SettingsContext,
  type Settings,
} from "./settings";

/** Holds connection settings in state and mirrors every change to localStorage. */
export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettingsState] = useState<Settings>(() => loadSettings());

  useEffect(() => {
    persistSettings(settings);
  }, [settings]);

  const value = useMemo(
    () => ({
      settings,
      setSettings: setSettingsState,
      hasKey:
        settings.jwt.trim().length > 0 || settings.apiKey.trim().length > 0,
      isSession: settings.jwt.trim().length > 0,
    }),
    [settings],
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}
